import {
	FOOTER_HEIGHT,
	FULL_HEIGHT,
	HEADER_HEIGHT
} from '@/core/constants/layout';

export const mainContentStyles = {
	mainContentRoot: {
		minHeight: `calc(100vh  - ${FOOTER_HEIGHT}px)`,
		minWidth: '100%',
		pt: `${HEADER_HEIGHT}px `,
		alignItems: 'stretch'
	},
	mainContentContainer: {
		p: 2,
		display: 'flex',
		flexDirection: 'row',
		width: '100%'
	},
	mainContentFullHeightBox: {
		height: FULL_HEIGHT,
		width: '100%'
	}
};
